import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["version"];
import React from 'react';
import { Helmet } from 'react-helmet';
import config from '../../config';
/* NOTE: SSR
 *
 * For server usage, follow the following guide:
 * (Must be documented on our docs-website)
 * https://github.com/nfl/react-helmet#server-usage
 *
 * TODO: Move reset to brand-specific cdn
 */

var Reset = function Reset(_ref) {
  var version = _ref.version,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  // eslint-disable-next-line no-console
  console.warn('[DEPRECATED](Reset): please import @mediahuis/chameleon-reset instead of using this component. For more information see: https://dev.azure.com/mediahuis/DNM/_packaging?_a=package&feed=pulse&package=%40mediahuis%2Fchameleon-reset&protocolType=Npm');
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", _extends({
    href: config.cdn.reset[version],
    rel: "stylesheet"
  }, rest)));
};

Reset.displayName = 'Reset';
Reset.identifier = Reset.displayName;
Reset.defaultProps = {
  version: config.cdn.reset.activeVersion
};
export default Reset;